import { Component, OnInit, TemplateRef, ChangeDetectionStrategy, inject } from '@angular/core';
import { PopoverContent, PopoverRef } from './popover-ref';
import { popoverAnimation } from '../../animations/popover.animation';
import { NgTemplateOutlet, NgComponentOutlet } from '@angular/common';

@Component({
	selector: 'vex-popover',
	templateUrl: './popover.component.html',
	styleUrls: ['./popover.component.scss'],
	animations: [popoverAnimation],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgTemplateOutlet, NgComponentOutlet],
})
export class PopoverComponent implements OnInit {
	private popoverRef = inject(PopoverRef);

	renderMethod: 'template' | 'component' | 'text' = 'component';
	content: PopoverContent;
	context;

	ngOnInit() {
		this.content = this.popoverRef.content;

		if (typeof this.content === 'string') {
			this.renderMethod = 'text';
		}

		if (this.content instanceof TemplateRef) {
			this.renderMethod = 'template';
			this.context = {
				close: this.popoverRef.close.bind(this.popoverRef),
			};
		}
	}
}
